import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { EmptyData } from '@shared/models';
import { ElasticSearchService } from '@shared/services/elastic-search';

@Component({
  selector: 'app-listing-pages-filtre',
  templateUrl: './listing-pages-filtre.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OptionCardComponent, RouterLink, SvgComponent],
})
export class ListingPagesFiltreComponent extends AbstractDynamicComponent<EmptyData> {
  private readonly elasticSearchService = inject(ElasticSearchService);
  protected readonly filterPages = toSignal(this.elasticSearchService.getFilterPages(), { initialValue: [] });
}
